import React, { useRef , useState }  from "react";
import { createRoot } from "react-dom/client"; // <-- IMPORT arriba
import PlayerDropboxNew from './PlayerDropboxNew'
import { useTranslation } from 'react-i18next';




function AboutNew(){
    const { t, i18n } = useTranslation();

    return(



        <div className="overlay-content" >

            <div className = "abouttext-main-container mt-lg-5" >      
                <div className="row  h-100 align-items-stretch">
                <div className="col-12 col-lg-6 d-flex ps-5">
                    <div className=" align-items-end row w-100">
                        <p className="lead font-face-opensans">{t('About1')}</p>
                        <p className="lead font-face-opensans">{t('About2')}</p>
                        <p className="lead font-face-opensans">{t('About3')}</p>
                        <p className="lead font-face-opensans">{t('About4')}</p>
                    </div>
                </div>

                <div className="col-12 col-lg-6 pt-lg-1 d-flex p-md-5 justify-content-center pe-lg-5"  >
                    <div  id="aboutimagecontainer" className="" >  
                    <img  
                    src="./images/ceciNew2.png"
                    className="img-fluid "
                    width="840" height="590" 
                   
                    />
                    </div>
                </div>
                </div>
            </div>

        </div>

    )
}
export default AboutNew